import React, { useState, useEffect } from "react";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Link, useNavigate } from "react-router-dom";
import { RiDashboardFill } from "react-icons/ri";
import { IoLogOut } from "react-icons/io5";
import { FaUserAlt, FaBuilding } from "react-icons/fa";
import { IoSettings } from "react-icons/io5";
import { MdOutlineLegendToggle } from "react-icons/md";
import "./Sidebar.css";
import { Images } from "../../utils/images";
import { successPopup, errorPopup } from "../../utils/ToasterMessage";

const SideNavbar = ({ isCollapse, setIsCollapse, handleToggleSidebar }) => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  // const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  // useEffect(() => {
  //   const handleResize = () => {
  //     setIsMobileView(window.innerWidth < 768);
  //     if (window.innerWidth >= 768) {
  //       setIsCollapse(false);
  //     }
  //   };

  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, [setIsCollapse]);


  const data = [
    {
      icon: <RiDashboardFill className="icon" />,
      activeIcon: <RiDashboardFill className="active icon hey" />,
      name: "Dashboard",
      link: "/dashboard",
    },
    {
      icon: <FaUserAlt className="icon" />,
      activeIcon: <FaUserAlt className="icon active" />,
      name: "User Management",
      link: "/user-management",
    },
    {
      icon: <FaBuilding className="icon" />,
      activeIcon: <FaBuilding className="icon active" />,
      name: "Company Management",
      link: "/company-management",
    },
    {
      icon: <IoSettings className="icon" />,
      activeIcon: <IoSettings className="icon active" />,
      name: "Setting",
      link: "/setting",
    },
  ];

  const handleLogout = () => {
    try {
      localStorage.clear();
      successPopup("Logout successfully");
      navigate("/login");
    } catch (error) {
      console.error("Error logging out:", error);
      errorPopup("Error logging out. Please try again.");
    }
  };

  const handleMenuClick = (index) => {
    setActiveIndex(index);
  };


  return (
    <div>
      <Sidebar
        className={isCollapse ? "sidebar-collapsed" : "sidebar-main"}
        backgroundColor="white"
        collapsed={isCollapse}
        width="260px"
        collapsedWidth="66px" 
        transitionDuration={300}
      >
        <Menu>
          <div className="sidebar-header">
            {!isCollapse && (
              <img src={Images?.kaamvala_logo} alt="Logo" width="119px" />
            )}
            <button
              className="sidebar-toggle-btn"
              onClick={handleToggleSidebar}
            >
               <img src={Images.hamburger} alt="hamb"/>
            </button>
          </div>

          {data.map((menuData, index) => (
            <MenuItem
              key={index}
              className={`menu-item ${activeIndex === index ? "active" : ""}`}
              onClick={() => handleMenuClick(index)}
              icon={activeIndex === index ? menuData.activeIcon : menuData.icon}
              component={<Link to={menuData.link} />}
            >
              {!isCollapse && menuData.name}
            </MenuItem>
          ))}

          <MenuItem
            key="logout"
            className="menu-item"
            icon={<IoLogOut className="icon" />}
            onClick={handleLogout}
          >
            {!isCollapse && "Logout"}
          </MenuItem>
        </Menu>
      </Sidebar>
    </div>
  );
};

export default SideNavbar;

